import type { TimelineStepperProps } from "../types/components.types";

export const TimelineStepper = ({
	count,
	selectedIndex = 0,
	onSelect,
}: TimelineStepperProps) => (
	<div className="relative flex flex-col items-center">
		<div className="-translate-x-1/2 absolute top-0 left-1/2 h-full w-px bg-gray-200" />

		{Array.from({ length: count }).map((_, index) => {
			const isSelected = index === selectedIndex;
			const stepKey = `step-${index}`;

			return (
				<div className="flex flex-1 items-center justify-center" key={stepKey}>
					<button
						className={`relative z-10 h-3 w-3 rounded-full border-2 transition-all focus:outline-none ${
							isSelected
								? "border-green-500 bg-green-500 shadow-[0_0_0_3px_rgba(34,197,94,0.15)]"
								: "border-gray-300 bg-white hover:border-green-400"
						}`}
						onClick={() => onSelect?.(index)}
						type="button"
					/>
				</div>
			);
		})}
	</div>
);

export { TimelineStepper as TripTimelineStepper };
